// extracted by mini-css-extract-plugin
module.exports = {"custom-toggle":"style_custom-toggle__1pmSt"};